// @owners { team: patients }
import { type ShipmentTip } from '@alto/scriptdash/alto/orders/types/v1/shipment_tip';

export const SET_SHIPMENT_TIPS = 'SET_SHIPMENT_TIPS';

export type SetShipmentTipsAction = {
  type: typeof SET_SHIPMENT_TIPS;
  payload: ShipmentTip[];
};

/**
 * Bridge setter: mirrors the React Query shipment-tips data into the Redux `shipmentTips` slice
 * so existing Reselect selectors (getShipmentTipForShipmentID → checkout's getOrder, etc.) keep
 * working without a Redux networking action. Replaces the deprecated fetchShipmentTipsForUser thunk.
 */
export function setShipmentTips(payload: ShipmentTip[]): SetShipmentTipsAction {
  return {
    type: SET_SHIPMENT_TIPS,
    payload,
  };
}
